<template>
  <div class="progressbarContainer">
    <v-progress-linear
      class="progress-bar"
      background-color="#ececec"
      color="#34c0be"
      height="12"
      :value="value"
    ></v-progress-linear>
    <div class="text text-purple">
      <div class="value">{{value}}%</div>
      <div class="suffix">Complete</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RunprProgressbar",
  props: ["value"]
};
</script>

<style scoped lang="scss">
.progressbarContainer {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  .progress-bar {
    display: block;
  }

  .text {
    text-align: right;
    display: block;
    margin-left: 16px;

    .value {
      font-size: 22px;
    }

    .suffix {
      font-size: 10px;
    }
  }

  .text-purple {
    color: #5d409f;
  }
}
</style>
